import React from 'react'
import Button from '@material-ui/core/Button'

const ExistingChoice = ({
  classes,
  sm,
  onChooseSameSchool,
  onChooseChange,
  publicCall
}) => (
  <div className={classes[sm ? 'buttons-sm' : 'buttons']}>
    <Button
      className={classes[sm ? 'button-sm' : 'button']}
      variant="contained"
      color="primary"
      onClick={onChooseSameSchool}
    >
      Desejo continuar na mesma escola
    </Button>

    <Button
      className={classes[sm ? 'button-sm' : 'button']}
      variant="contained"
      color="primary"
      onClick={onChooseChange}
    >
      {publicCall.changeSchoolButtonText}
    </Button>
  </div>
)

export default ExistingChoice
